<script lang="ts">
    import {
        VpCalendarIcon,
        VpMapPinIcon,
        VpRunIcon,
        VpEqualizerIcon,
        VpEditIcon,
        VpAddIcon,
        VpRefreshIcon,
    } from '@decathlon-experience/icons/svelte';

    import viewport from '$saga/actions/useViewport';
    import { FilterType } from '$saga/views/Search/types';
    import Button from '$saga/components/Button.svelte';
    import {
        filtersContext,
        areSecondaryFiltersActive,
    } from '$saga/views/Search/store';
    import cn from '$common/utils/cn';

    export let trigger, handleSelectedFilter;

    let isSticky = false;
    let filtersBarContainer: HTMLDivElement | null = null;
</script>

<div
    use:viewport
    on:enterViewport={() => {
        if (!$filtersContext.isHomePage) isSticky = false;
    }}
    on:exitViewport={() => {
        if (!$filtersContext.isHomePage) isSticky = true;
    }}
/>
{#if isSticky}
    <div
        class="h-[42px] desktop:hidden"
        style="height: {filtersBarContainer?.clientHeight ?? '88'}px"
    />
{/if}

<div
    class={cn(
        'relative m-auto hidden h-[42px] max-w-layout-max desktop:block',
        isSticky && !$filtersContext.isHomePage && '!max-w-full',
    )}
>
    <div
        bind:this={filtersBarContainer}
        class={cn(
            'absolute top-[-42px] w-full px-5xl transition-all',
            isSticky &&
                !$filtersContext.isHomePage &&
                'fixed top-0 z-10 w-full !px-0',
        )}
    >
        <div class="border border-solid border-bord-quiet bg-white px-s py-m">
            <div class="flex gap-s">
                <button
                    class="flex w-full items-center justify-between bg-container-quiet p-s hover:bg-container-commercial-neutral"
                    on:click|preventDefault|stopPropagation={() => {
                        handleSelectedFilter(FilterType.SPORT);
                    }}
                    {...$trigger}
                    use:trigger
                >
                    {#if $filtersContext.formLabels.theme.length > 0}
                        <span
                            class="flex items-center gap-xs text-sm text-content-brand"
                        >
                            <VpRunIcon class="size-m" />
                            Sport ({$filtersContext.formLabels.theme.length})
                        </span>
                        <span class=""><VpEditIcon size={16} /></span>
                    {:else}
                        <span class="flex items-center gap-xs text-sm">
                            <VpRunIcon class="size-m" />
                            Sport
                        </span>
                        <span class=""><VpAddIcon size={16} /></span>
                    {/if}
                </button>
                <button
                    class="flex w-full items-center justify-between bg-container-quiet p-s hover:bg-container-commercial-neutral"
                    on:click|preventDefault|stopPropagation={() => {
                        handleSelectedFilter(FilterType.DESTINATION);
                    }}
                    {...$trigger}
                    use:trigger
                >
                    {#if $filtersContext.formLabels.destination.length > 0}
                        <span
                            class="flex items-center gap-xs text-sm text-content-brand"
                        >
                            <VpMapPinIcon class="size-m" />
                            Destination ({$filtersContext.formLabels.destination
                                .length})
                        </span>
                        <span class=""><VpEditIcon size={16} /></span>
                    {:else}
                        <span class="flex items-center gap-xs text-sm">
                            <VpMapPinIcon class="size-m" />
                            Destination
                        </span>
                        <span class=""><VpAddIcon size={16} /></span>
                    {/if}
                </button>
                <button
                    class="flex w-full items-center justify-between bg-container-quiet p-s hover:bg-container-commercial-neutral"
                    on:click|preventDefault|stopPropagation={() => {
                        handleSelectedFilter(FilterType.STARTDATE);
                    }}
                    {...$trigger}
                    use:trigger
                >
                    {#if $filtersContext.formLabels.startDate != null}
                        <span
                            class="flex items-center gap-xs whitespace-nowrap text-sm text-content-brand"
                            ><VpCalendarIcon class="size-m" />
                            Date de départ (1)
                        </span>
                        <span class=""><VpEditIcon size={16} /></span>
                    {:else}
                        <span
                            class="flex items-center gap-xs whitespace-nowrap text-sm"
                        >
                            <VpCalendarIcon class="size-m" />
                            Date de départ
                        </span>
                        <span class=""><VpAddIcon size={16} /></span>
                    {/if}
                </button>
                <button
                    class="flex w-full items-center justify-between bg-container-quiet p-s hover:bg-container-commercial-neutral"
                    on:click|preventDefault|stopPropagation={() => {
                        handleSelectedFilter(FilterType.PAX);
                    }}
                    {...$trigger}
                    use:trigger
                >
                    {#if $filtersContext.formLabels.nbPax !== '' && $filtersContext.formLabels.nbPax !== '0'}
                        <span
                            class="flex items-center gap-xs text-sm text-content-brand"
                        >
                            <VpCalendarIcon class="size-m" />
                            Voyageurs ({$filtersContext.formLabels.nbPax})
                        </span>
                        <span class=""><VpEditIcon size={16} /></span>
                    {:else}
                        <span class="flex items-center gap-xs text-sm">
                            <VpCalendarIcon class="size-m" />
                            Voyageurs
                        </span>
                        <span class=""><VpAddIcon size={16} /></span>
                    {/if}
                </button>
                <Button type="submit" form="travel-search-engine-form">
                    {#if $filtersContext.isSubmitting}
                        <VpRefreshIcon class="size-xl animate-spin " />
                    {:else}
                        Rechercher
                    {/if}
                </Button>
                {#if !$filtersContext.isHomePage}
                    <button
                        class="vp-button vp-button--secondary vp-button--squared h-full capitalize"
                        type="button"
                        on:click|preventDefault|stopPropagation={() => {
                            handleSelectedFilter(FilterType.SELECTION);
                        }}
                        {...$trigger}
                        use:trigger
                    >
                        <span class="vp-button__label">
                            <span data-part="start-slot">
                                <VpEqualizerIcon />
                            </span>
                            Filtres
                            {#if $areSecondaryFiltersActive}
                                <div class="ml-1 h-xl w-fit">
                                    <div
                                        class="mb-auto size-[7px] rounded-full bg-blue-brand"
                                    ></div>
                                </div>
                            {/if}
                        </span>
                    </button>
                {/if}
            </div>
        </div>
    </div>
</div>
